module.exports = __webpack_public_path__ + "img/Rectangle 46.9cefaf51.svg";